import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-24 md:py-32 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-black rounded-2xl px-8 py-16 md:py-20 flex flex-col items-center gap-6">
          <p className="text-sm font-medium uppercase tracking-wider bg-gradient-to-r from-teal-400 to-indigo-400 bg-clip-text text-transparent">Get Started</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight">
            Ready to Automate Your<br />Travel Business?
          </h2>
          <p className="text-sm text-gray-400 max-w-md leading-relaxed">
            Join 500+ travel agencies already using Trewaz to handle enquiries, automate WhatsApp, and convert more bookings — all on autopilot.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/register"
              className="bg-white text-black text-sm font-medium px-6 py-3 rounded-md hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Free Trial
            </Link>
            <a
              href="#how-it-works"
              className="border border-gray-600 text-gray-300 text-sm font-medium px-6 py-3 rounded-md hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Book a Demo
            </a>
          </div>
          <p className="text-xs text-gray-500">No credit card required • Free 14-day trial • Cancel anytime</p>
        </div>
      </div>
    </section>
  );
}
